import * as React from 'react';
import { Col, Row } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { HeaderView } from 'src/app/shared/header.view';
import { CardController } from 'src/app/shared/card.controller';
import { TextView } from 'src/core/ui/text.view';
import { BooleanView } from 'src/core/ui/boolean.view';
import RolePermissionController from './parts/role-permission-list.controller';

interface Props extends ComponentViewProps<RoleItem> {
	title: string;
	save: () => void;
	cancel: () => void;
	mode: ControlMode;
	isAdministrator: boolean;
	operation: 'new' | 'update';
	permissions: Array<PermissionItem>;
	onModeChanged: (mode: ControlMode) => void;
	contextService: any;
}

@observer
export class RoleFormView extends React.Component<Props, {}> {
	constructor(props: Readonly<Props>) {
		super(props);
	}

	render() {
		const {
			title, save, cancel, onModeChanged, mode, model,
			setBusy, operation, isAdministrator, permissions
		} = this.props;
		if (model == null) {
			return null;
		}

		return (
			<div className="window window-normal">
				<Prompt
					when={this.props.contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<Row>
					<Col xs={24} lg={{ offset: 3, span: 18 }}>
						<Row>
							<Col xs={24}>
								<HeaderView
									title={title}
									mode={mode}
									onModeChanged={onModeChanged}
									save={save}
									cancel={cancel}
									contextService={this.props.contextService}
								/>
							</Col>
						</Row>
						<CardController
							mode={mode}
							icon="fa fa-book"
							title="Role information">
							<Row gutter={16}>
								<Col xs={16}>
									<TextView
										required
										label="Name"
										value={model.displayName}
										onChanged={newVal => {
											model.userName = newVal;
											model.displayName = newVal;
										}}
										onGetErrorMessage={() => model.validate(true, 'userName')}
										mode={isAdministrator ? mode : 'display'}
									/>
								</Col>
								<Col xs={8}>
									<BooleanView
										label="Is Administrator Role"
										value={model.isAdmin}
										onChanged={newVal => model.isAdmin = newVal}
										mode={mode}
									/>
								</Col>
							</Row>
							<Row>
								<Col xs={24}>
									<RolePermissionController mode={mode} permissions={permissions} role={model} />
								</Col>
							</Row>
						</CardController>
					</Col>
				</Row>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/roles/form/role-form.view.tsx